import * as React from "react";
import { SVGProps } from "react";

const SvgComponent = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 -11 70 48"
    {...props}
  >
    <rect
      width={69}
      height={47}
      x={0.5}
      y={-10.5}
      fill="#fff"
      stroke="#d9d9d9"
      rx={5.5}
    />
    <path
      fill="#3c4043"
      fillRule="evenodd"
      d="M33.06 20.516v-6.042h3.119c1.277 0 2.356-.428 3.235-1.272l.211-.214a4.35 4.35 0 0 0-.21-6.09 4.45 4.45 0 0 0-3.236-1.296h-5.006v14.914Zm0-7.873v-5.21h3.166c.68 0 1.325.262 1.806.738 1.02.999 1.043 2.664.059 3.698a2.45 2.45 0 0 1-1.865.773zm15.37-1.535c-.81-.749-1.911-1.13-3.307-1.13-1.793 0-3.141.666-4.032 1.987l1.664 1.058c.61-.904 1.442-1.356 2.497-1.356.669 0 1.313.25 1.817.702a2.25 2.25 0 0 1 .774 1.7v.44c-.727-.404-1.641-.618-2.767-.618-1.312 0-2.368.31-3.153.94-.785.63-1.184 1.463-1.184 2.521a3.173 3.173 0 0 0 1.114 2.498c.738.666 1.676 1 2.778 1 1.301 0 2.333-.584 3.118-1.75h.082v1.416h1.806v-6.292c0-1.32-.399-2.366-1.208-3.116zm-5.123 7.529a1.55 1.55 0 0 1-.622-1.249c0-.559.258-1.023.762-1.392.516-.368 1.161-.558 1.923-.558 1.055-.012 1.876.226 2.462.701 0 .809-.316 1.51-.938 2.105a2.978 2.978 0 0 1-2.122.892 2.284 2.284 0 0 1-1.465-.5zM53.693 25 60 10.31h-2.052l-2.919 7.327h-.035l-2.99-7.327h-2.05l4.138 9.55L51.747 25z"
      clipRule="evenodd"
    />
    <path
      fill="#4285f4"
      d="M26.544 13.166c0-.583-.047-1.166-.14-1.737h-7.96v3.295h4.56a3.97 3.97 0 0 1-1.688 2.605v2.14h2.72c1.594-1.486 2.508-3.687 2.508-6.303z"
    />
    <path
      fill="#34a853"
      d="M18.444 21.539c2.274 0 4.197-.761 5.592-2.07l-2.72-2.14c-.762.523-1.735.82-2.872.82-2.204 0-4.068-1.51-4.736-3.532h-2.802v2.212c1.43 2.89 4.35 4.71 7.538 4.71z"
    />
    <path
      fill="#fbbc04"
      d="M13.708 14.617a5.238 5.238 0 0 1 0-3.283v-2.2h-2.802a8.6 8.6 0 0 0 0 7.683Z"
    />
    <path
      fill="#ea4335"
      d="M18.444 7.802a4.507 4.507 0 0 1 3.236 1.284l2.415-2.45a8.083 8.083 0 0 0-5.65-2.224c-3.19 0-6.109 1.832-7.539 4.722l2.802 2.212c.668-2.034 2.532-3.544 4.736-3.544z"
    />
  </svg>
);

export default SvgComponent;
